"use client";

import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
} from "@/utils/library/languages";

export function LanguageSetter({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const pathname = usePathname();

  const segment = pathname.split("/")[1];
  const lang = (SUPPORTED_LANGUAGES as readonly string[]).includes(segment)
    ? segment
    : DEFAULT_LANGUAGE;

  if (i18n.language !== lang) {
    i18n.changeLanguage(lang);
  }

  return <>{children}</>;
}
